import { useCallback } from 'react'

import { useParams } from 'react-router'

import LeftChevronIcon from '@/assets/icons/icon-chevron-left.svg'
import RightChevronIcon from '@/assets/icons/icon-chevron-right.svg'
import { Button } from '@/components/ui/button.tsx'

import { courseVideos } from '../../data/course-videos.ts'
import { useCourse } from '../../hooks/useCourse'

export const SwitchVideoButtons = () => {
  const { currentVideoId, setCurrentVideo } = useCourse()

  const { category } = useParams()

  const handleSwitchClick = useCallback(
    (counter: number) => () => {
      const categoryVideos = courseVideos.find(
        (video) => video.name === category,
      )?.videos

      if (categoryVideos && currentVideoId) {
        const currentVideoIndex = categoryVideos?.findIndex(
          (video) => video.video_id === currentVideoId,
        )

        // clicking previous for first video
        if (counter < 0 && currentVideoIndex === 0) {
          setCurrentVideo(categoryVideos[categoryVideos.length - 1].video_id)
        }

        // clicking next for last video
        else if (
          counter > 0 &&
          currentVideoIndex === categoryVideos.length - 1
        ) {
          setCurrentVideo(categoryVideos[0].video_id)
        }

        // default click
        else
          setCurrentVideo(categoryVideos[currentVideoIndex + counter].video_id)
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [courseVideos, category, currentVideoId],
  )

  return (
    <div className="flex items-center max-sm:w-full max-sm:justify-between">
      <Button
        className="whitespace-nowrap hover:bg-primary-500/10"
        variant="ghost"
        onClick={handleSwitchClick(-1)}
      >
        <LeftChevronIcon className="fill-primary-500" />
        Previous Video
      </Button>
      <Button
        className="whitespace-nowrap hover:bg-primary-500/10"
        variant="ghost"
        onClick={handleSwitchClick(1)}
      >
        Next Video
        <RightChevronIcon className="fill-primary-500" />
      </Button>
    </div>
  )
}
